import React, { Component } from 'react'
import { observer } from 'mobx-react'

import CompanyTable from './companytable'

@observer(['companies', 'globals'])
export default class Customers extends Component {

  constructor(props) {
    super(props)

    if (this.props.companies.customers.length == 0) {  
      this.props.companies.loadAllCustomers()
    }
  }

  reload(callback) {
    this.props.companies.loadAllCustomers(() => {
      if (callback != null) {
        callback()
      }
    })
  }

  render() {
    return (
      <div>
        <CompanyTable companyTypeHeading={ 'Customer' } companyStateId={ 3 } data={ this.props.companies.customers } reload={ this.reload.bind(this) } />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/companies/customers.js